import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export const anggaranPemasukanTable = (
  handleEdit,
  handleDelete,
  handleShowDetail
) => {
  return [
    {
      title: "Id Anggaran",
      render: (rowData) => {
        return <span>{rowData.id_anggaran_pemasukan}</span>;
      },
    },
    {
      title: "Unit Usaha",
      render: (rowData) => {
        return <span>{rowData.unit_usaha}</span>;
      },
    },
    {
      title: "Kode Akun",
      render: (rowData) => {
        return <span>{rowData.kode_akun}</span>;
      },
    },
    {
      title: "Nama Anggaran Pemasukan",
      render: (rowData) => {
        return <span>{rowData.nama_anggaran_pemasukan}</span>;
      },
    },
    {
      title: "Jumlah",
      render: (rowData) => {
        return <span>{CurrencyFormat(rowData.jumlah_anggaran_pemasukan)}</span>;
      },
    },
    {
      title: "Tahun",
      render: (rowData) => {
        return <span>{rowData.tahun_anggaran_pemasukan}</span>;
      },
    },
    // {
    //   title: "Created At",
    //   render: (rowData) => {
    //     return <span>{rowData.created_at}</span>;
    //   },
    // },
    // {
    //   title: "Updated At",
    //   render: (rowData) => {
    //     return <span>{rowData.updated_at}</span>;
    //   },
    // },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleEdit(rowData)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleDelete(rowData)}
            >
              Delete
            </button>
            <button
              className="bg-lightBlue-500 hover:bg-lightBlue-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleShowDetail(rowData)}
            >
              <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
            </button>
          </>
        );
      },
    },
  ];
};
